import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { useAuth } from "@/context/AuthContext";
import { BrandLogo } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/how-it-works", label: "How It Works" },
  { to: "/services", label: "Services" },
  { to: "/become-a-placement-professional", label: "Become a Pro" },
  { to: "/build-your-business", label: "Build a Business" },
  { to: "/providers", label: "Providers" },
  { to: "/commission-opportunities", label: "Opportunities" },
  { to: "/commission-calculator", label: "Calculator" },
  { to: "/business-in-a-box", label: "Business-in-a-Box" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
];

export default function PublicNav() {
  const settings = useSettings();
  const { user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/95 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Link to="/" data-testid="nav-home-logo"><BrandLogo /></Link>

        <nav className="hidden items-center gap-1 xl:flex">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`nav-${n.to.replace(/\//g, "")}`}
              className={`rounded-md px-2.5 py-2 text-[13px] font-medium transition-colors hover:text-clinical ${
                loc.pathname === n.to ? "text-clinical" : "text-slate-600"}`}>
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden items-center gap-2 lg:flex">
          {user ? (
            <Button data-testid="nav-dashboard-btn" onClick={() => nav(user.role === "OWNER" || user.role === "ADMIN" ? "/admin" : "/app")}
              className="bg-navy hover:bg-navy/90">Dashboard</Button>
          ) : (
            <Button variant="ghost" data-testid="nav-login-btn" onClick={() => nav("/login")} className="text-slate-700">Login</Button>
          )}
          <Button data-testid="nav-join-btn" onClick={() => nav("/join")} className="bg-clinical hover:bg-clinical/90">
            Join — {settings.membership_price}
          </Button>
        </div>

        <button className="xl:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X className="h-6 w-6 text-navy" /> : <Menu className="h-6 w-6 text-navy" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-slate-200 bg-white xl:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col p-4">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50">{n.label}</Link>
            ))}
            <div className="mt-3 flex flex-col gap-2">
              {user ? (
                <Button onClick={() => { setOpen(false); nav(user.role === "OWNER" || user.role === "ADMIN" ? "/admin" : "/app"); }} className="bg-navy">Dashboard</Button>
              ) : (
                <Button variant="outline" onClick={() => { setOpen(false); nav("/login"); }}>Login</Button>
              )}
              <Button onClick={() => { setOpen(false); nav("/join"); }} className="bg-clinical">Join — {settings.membership_price}</Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
